import {
  SET_WIDGET_TITLE,
  SET_PUBLISHERS,
  SET_PUBLISHER,
  SET_PUBLISHER_REFERENCES,
  SET_CHECK_REFERENCES_TEXT,
  SET_USER_VISIBLE_COLUMNS,
  SET_INVITES_FOR_PUBLISHER,
  SET_SHOW_NEW_PUBLISHER_INVITES,
  SET_ACCOUNT_SETTINGS
} from './mutationTypes';

import {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError
} from '@/store/helpers';
import cloneDeep from 'lodash/cloneDeep';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_PUBLISHERS](state, publishers) {
    state.publishers = publishers;
  },
  [SET_WIDGET_TITLE](state, title) {
    state.widget.title = title;
  },
  [SET_USER_VISIBLE_COLUMNS](state, userVisibleColumns) {
    state.userVisibleColumns = userVisibleColumns;
  },
  [SET_PUBLISHER_REFERENCES](state, publisherReferences) {
    state.publisherReferences = publisherReferences;
  },
  [SET_CHECK_REFERENCES_TEXT](state, checkReferencesText) {
    state.checkReferencesText = checkReferencesText;
  },
  [SET_PUBLISHER](state, { index, publisher }) {
    const arrayToUpdate = cloneDeep(state.publishers);
    arrayToUpdate[index] = publisher;
    state.publishers = arrayToUpdate;
  },
  [SET_INVITES_FOR_PUBLISHER](state, { publisher }) {
    state.invitesForPublisher = publisher;
  },
  [SET_SHOW_NEW_PUBLISHER_INVITES](state, { showNewPublisherInvites }) {
    state.showNewPublisherInvites = showNewPublisherInvites;
  },
  [SET_ACCOUNT_SETTINGS](state, accountSettings ) {
    state.accountSettings = accountSettings;
  },
};
